import { gql } from '@apollo/client'

export interface IDeliveryScheduleLocation {
  locationId: number
  locationName: string
  locationCode: string
  deliveryDays: string
  effectiveDate: string | null
}

export interface IDeliveryScheduleLocationsType {
  getDeliveryScheduleLocations: {
    nodes: IDeliveryScheduleLocation[]
  }
}

export const getDeliveryScheduleLocations = gql`
  query GetDeliveryScheduleLocations {
    getDeliveryScheduleLocations {
      nodes {
        locationId
        locationName
        locationCode
        deliveryDays
        effectiveDate
      }
    }
  }
`

// Delivery day prep items — items that stay ON during delivery days
export interface IDeliveryDayPrepItem {
  prepItemId: string
  prepItemName: string
}

export interface IDeliveryDayPrepItemsType {
  getDeliveryDayPrepItems: {
    nodes: IDeliveryDayPrepItem[]
  }
}

export const getDeliveryDayPrepItems = gql`
  query GetDeliveryDayPrepItems {
    getDeliveryDayPrepItems {
      nodes {
        prepItemId
        prepItemName
      }
    }
  }
`

// --- Delivery Schedules ---

export interface IDeliverySchedule {
  scheduleId: number
  scheduleName: string
  scheduleType: string
  startDate: string
  endDate: string | null
  status: string
  storeIds: number[]
  storeCount: number
  combinationCount: number
  createdBy: string
  createdAt: string
}

export interface IDeliverySchedulesType {
  getDeliverySchedules: {
    nodes: IDeliverySchedule[]
  }
}

export const getDeliverySchedules = gql`
  query GetDeliverySchedules {
    getDeliverySchedules {
      nodes {
        scheduleId
        scheduleName
        scheduleType
        startDate
        endDate
        status
        storeIds
        storeCount
        combinationCount
        createdBy
        createdAt
      }
    }
  }
`
